import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DrawerTransitionContext = createContext();

export const useDrawerTransition = () => useContext(DrawerTransitionContext);

export const DrawerTransitionProvider = ({ children }) => {
    const [showDrawer, setShowDrawer] = useState(false);
    const [active, setActive] = useState(false);
    const [targetPath, setTargetPath] = useState(null);
    const [isAnimating, setIsAnimating] = useState(false);
    const [param, setparam] = useState(false);

    const navigate = useNavigate();

    const startTransition = (path, param) => {
        setShowDrawer(true); // render drawer
        setIsAnimating(true);
        setTimeout(() => {
            setActive(true); // activate animation
        }, .8); // short delay to trigger transition
        setparam(param)
        setTargetPath(path);
    };

    useEffect(() => {
        if (active && targetPath) {
            const timeout = setTimeout(() => {
                setActive(false);
                setShowDrawer(false);
                setIsAnimating(false);
                window.scrollTo(0, 0);
                navigate(targetPath, { state: param });
            }, 1000); // match CSS transition duration

            return () => clearTimeout(timeout);
        }
    }, [active, targetPath, navigate]);

    return (
        <DrawerTransitionContext.Provider value={{ startTransition, isAnimating }}>
            {children}
            {showDrawer && (
                <div className={`drawer-transition ${active ? 'active' : ''}`} />
            )}
        </DrawerTransitionContext.Provider>
    );
};
